export function createQueryKeys(workspaceId: string) {
  const createBoardPostsKey = (boardId: string) =>
    [workspaceId, 'board', 'posts', boardId] as const;
  return {
    all: [workspaceId] as const,
    workspace: {
      detail: () => [workspaceId, 'workspace'] as const,
      usage: () => [workspaceId, 'workspace', 'usage'] as const,
    },

    board: {
      all: () => [workspaceId, 'board'] as const,
      lists: () => [workspaceId, 'board', 'lists'] as const,
      detail: (boardId: string) => [workspaceId, 'board', 'detail', boardId] as const,
      postsRoot: (boardId: string) => createBoardPostsKey(boardId),
      posts: (boardId: string, params?: { page?: number; limit?: number } | null) =>
        [
          ...createBoardPostsKey(boardId),
          'page',
          params?.page ?? 0,
          'limit',
          params?.limit ?? 20,
        ] as const,
      infinitePosts: (boardId: string, limit: number) =>
        [...createBoardPostsKey(boardId), 'infinite', 'limit', limit] as const,
    },

    creator: {
      all: () => [workspaceId, 'creator'] as const,
      searchStatus: (searchId: string) =>
        [workspaceId, 'creator', 'search-status', searchId] as const,
    },
  };
}

export type QueryKeys = ReturnType<typeof createQueryKeys>;
